import request from '@/utils/request'

export function register(user) {
  return request({
    url: '/auth/register',
    method: 'post',
    data: user
  })
}

export function login(mobile, password) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: { mobile, password }
  })
}

export function logout(refresh_token) {
  return request({
    url: '/auth/logout',
    method: 'post',
    data: { refresh_token }
  })
}
